import ChatRoomVue from '@/views/sm/chat-room/chat-room.vue';

const basePath = '/sm/chat-room';
const role = 'sm'; // 角色身份

export const SM_CHAT_ROOM_INDEX = 'sm-chat-room-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ChatRoomVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SM_CHAT_ROOM_INDEX,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/chat-room/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
